const data = [
  {
    id: 1,
    name: 'Christian Porter',
    jobTitle: 'Former Attorney General',
    img: 'christian_porter',
    heading: 'Blind trust',
    year: 2021,
    points: [
        'Part of Porter’s legal fees for a defamation action he took against the ABC had been paid from “a blind trust”<sup>6</sup>',
        'Porter doesn’t know who donated to the trust<sup>7</sup>',
        'Hidden money in politics is a huge problem for our democracy<sup>8</sup>',
    ],
    isActive: false,
  },
  {
    id: 2,
    name: 'Alan Tudge',
    jobTitle: 'Former Minister for Cities, Urban Infrastructure and Population',
    img: 'alan_tudge',
    heading: 'Commuter car park rorts',
    year: 2019,
    points: [
        'Distributed $660 million for car park construction during the 2019 election in seats hand-picked based on advice from MPs and candidates<sup>9</sup>',
        '77% of the car park sites selected were in Coalition electorates<sup>10</sup>',
        'An Inquiry found ​​a “marginal electorate list” had been the starting point for funding decisions<sup>11</sup>',
    ],
    isActive: false,
  },
  {
    id: 3,
    name: 'Michael Sukkar',
    jobTitle: 'Assistant Treasurer',
    img: 'michael_sukkar',
    heading: 'Public funds for political gain',
    year: 2021,
    points: [
        'Had intimate knowledge of an alleged scheme using public resources to boost Sukkar’s factional power base<sup>12</sup>',
        'Sukkar’s best friend, younger brother and factional supporters were employed as part of the scheme<sup>13</sup>',
        'Sukkar denies branch stacking  allegations, pointing to a Department report which he strongly argued to be kept secret<sup>14</sup>',
    ],
    isActive: false,
  },
  {
    id: 4,
    name: 'Bridget McKenzie',
    jobTitle: 'Former Minister for Sports',
    img: 'bridget_mckenzie',
    heading: 'Sports rorts',
    year: 2020,
    points: [
      'Dished out the majority of $100 million of sports grants to marginal electorates just before the 2019 federal election<sup>15</sup>',
      'While sports clubs with decaying toilets and old tin shacks went without, a lavish rowing club in one of Sydney’s richest suburbs pocketed $500,000<sup>16</sup>',
      'A spreadsheet colour-coded by political parties was even used in decision-making<sup>17</sup>',
      '73% of the projects approved were not recommended by Sport Australia<sup>18</sup>',
    ],
    isActive: false,
  },
  {
    id: 5,
    name: 'Angus Taylor',
    jobTitle: 'Minister for Energy and Emissions Reduction',
    img: 'angus_taylor',
    heading: 'Dodgy council documents',
    year: 2019,
    points: [
      'Accused Sydney Lord Mayor Clover Moore of spending $15 million on climate-polluting travel based on falsified documents provided to the Daily Telegraph<sup>19</sup>',
      'Taylor has claimed he downloaded the documents from the City of Sydney council website but a preliminary police investigation could find no evidence that this was true<sup>20</sup>',
      'Taylor was accused of misleading parliament over the saga<sup>21</sup>',
      'The origin of the documents has never been determined<sup>22</sup>',
    ],
    isActive: false,
  },
  {
    id: 6,
    name: 'Michael McCormack',
    jobTitle: 'Former Deputy Prime Minister',
    img: 'michael_mccormack',
    heading: 'Regional growth grants',
    year: 2019,
    points: [
      'Oversaw $272 million in regional funding grants that favoured Coalition electorates in the lead up to the 2019 election<sup>23</sup>',
      '90% of the funding went to Coalition and marginal electorates<sup>24</sup>',
      'Think the sports rorts scandal, but even bigger!',
    ],
    isActive: false,
  },
  {
    id: 7,
    name: 'Eric Abetz',
    jobTitle: 'Senator for Tasmania',
    img: 'eric_abetz',
    heading: 'Publicly funded mining gala',
    year: 2018,
    points: [
      'Spent $3,000 of public money to attend a luxury dinner celebrating the mining industry<sup>25</sup>',
      'The publicly funded expenses included flights and private cars<sup>26</sup>',
      'A headline speech was given by John Howard<sup>27</sup>',
      'Abetz has no ministerial connection to mining and defended the trip as being in the interests of Tasmania<sup>28</sup>',
    ],
    isActive: false,
  },
  {
    id: 8,
    name: 'Josh Frydenberg',
    jobTitle: 'Former Minister for the Environment',
    img: 'josh_frydenberg',
    heading: 'Great Barrier Reef grant',
    year: 2018,
    points: [
      'Gave $443 million of Great Barrier Reef funding to an obscure foundation as Environment Minister<sup>29</sup>',
      'The foundation had corporate connections to climate denial groups and fossil fuel companies<sup>30</sup>',
      'No open, competitive tender was held for the controversial grant<sup>31</sup>',
      'The Foundation has failed to deliver on its promise to raise hundreds of millions of dollars to save the embattled reef<sup>32</sup>',
    ],
    isActive: false,
  },
  {
    id: 9,
    name: 'Barnaby Joyce',
    jobTitle: 'Former Minister for Agriculture and Water Resources',
    img: 'barnaby_joyce',
    heading: 'Water-gate buybacks scandal',
    year: 2017,
    points: [
      'Approved an $80 million dollar deal to buy back water from a corporation formerly directed by Angus Taylor<sup>33</sup>',
      'The money was transferred to a parent corporation in the Cayman Islands – a known tax haven<sup>34</sup>',
      'The deal had no open tender process<sup>35</sup>',
      'It was found to be bad value for public money<sup>36</sup>',
      'The corporation declared a $52 million dollar profit<sup>37</sup>',
    ],
    isActive: false,
  },
  {
    id: 10,
    name: 'Mitch Fifield',
    jobTitle: 'Former Minister for Communications',
    img: 'mitch_fifield',
    heading: 'Handouts for Foxtel',
    year: 2017,
    points: [
      'Oversaw a $30 million handout to Murdoch’s Fox Sports<sup>38</sup>',
      'The funding was ostensibly for women’s sport, but was not attached to any guidelines or conditions<sup>39</sup>',
      'The ABC has to pay Foxtel to show women’s sport, meaning the public pays twice<sup>40</sup>',
      'Fifield was also asked to explain the gift of cufflinks he received from Foxtel later that year but refused to comment<sup>41</sup>',
    ],
    isActive: false,
  },
  {
    id: 11,
    name: 'Peter Dutton',
    jobTitle: 'Former Minister for Home Affairs',
    img: 'peter_dutton',
    heading: 'Au pair intervention',
    year: 2015,
    points: [
      'Directly intervened to grant special tourist visas for two women working as au pairs<sup>42</sup>',
      'One worked for a former colleague in the Queensland police force<sup>43</sup>',
      'Reports and departmental emails suggest Dutton took extraordinary measures to overrule border security advice at a moment’s notice<sup>44</sup>',
      'A Senate Inquiry was set up to investigate the circumstances of Dutton’s intervention, and found he misled Parliament<sup>45</sup>',
    ],
    isActive: false,
  },
]

export default data
